<template>
  <div class="app-container" v-if="form">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="tab-box"><span :class="{'active': tabType}" @click="tabType = 1">基础信息</span><span v-if="form.isMoreSpec" :class="{'active': !tabType}" @click="tabType = 0">规格</span></div>
      <template v-if="tabType">
        <div class="title-box"><span class="txt1">商品基础信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="商品编码">{{form.uuid}}</el-descriptions-item>
          <el-descriptions-item label="有无规格">{{form.isMoreSpec?'有':'无'}}</el-descriptions-item>
          <el-descriptions-item label="聚水潭编码" v-if="form.youCode">{{form.youCode}}</el-descriptions-item>
          <el-descriptions-item label="税收分类编码">{{form.taxCode}}</el-descriptions-item>
          <el-descriptions-item label="商品规格">{{form.spec}}</el-descriptions-item>
          <el-descriptions-item label="产品规格">{{form.productSpec}}<template v-if="form.productSpec">（{{specSourceText}}）</template></el-descriptions-item>
          <el-descriptions-item label="商品名称">{{form.name}}</el-descriptions-item>
          <el-descriptions-item label="曾用名">{{form.aliasName}}</el-descriptions-item>
          <el-descriptions-item label="商品分类"><span v-for="(item,index) in rowItem.sysGoodsCategorizeList" :key="index">{{item.name}}{{rowItem.sysGoodsCategorizeList.length - 1 != index?',':''}}</span></el-descriptions-item>
          <el-descriptions-item label="供应商" v-if="form.supplier">{{form.supplier}}</el-descriptions-item>
          <el-descriptions-item label="虚拟销售量">{{form.virtualSalesCount}}</el-descriptions-item>
          <el-descriptions-item label="起购数量" v-if="form.buyMinCount">{{form.buyMinCount}}</el-descriptions-item>
          <el-descriptions-item label="预计预售发货时间">{{form.sendDay}}天</el-descriptions-item>
          <el-descriptions-item label="商品主图"><el-image style="width: 50px; height: 50px" :src="form.img" :preview-src-list="[form.img]"></el-image></el-descriptions-item>
          <el-descriptions-item label="显示商城" v-if="goodsType"> <span v-for="(item,index) in rowItem.sysGoodsAreaList" :key="index">{{mallAreaName(item)}}{{rowItem.sysGoodsAreaList.length - 1 != index?',':''}}</span></el-descriptions-item>
          <el-descriptions-item label="商品Banner图">
            <div v-if="form.bannerImg">
              <el-image class="banner-box" v-for="(item,index) in form.bannerImg && form.bannerImg.split(',')" :key="index" :src="item" :preview-src-list="[item]"></el-image>
            </div>

          </el-descriptions-item>
          <el-descriptions-item label="视频">
            <div v-if="form.video">
              <video :autoplay="false" :controls="true" style="width: 100px;height: 50px;" :src="form.video"></video>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="是否限制时间">{{form.isControlTime?'限制':'不限制'}}</el-descriptions-item>
          <el-descriptions-item label="上下架时间" v-if="form.listingStartTime && form.listingEndTime"> {{form.listingStartTime}} ~ {{form.listingEndTime}}</el-descriptions-item>
          <el-descriptions-item label="是否限购">{{form.isQuota?'限购':'不限购'}}</el-descriptions-item>
          <el-descriptions-item label="限购数量" v-if="form.isQuota">{{form.quotaNum}}</el-descriptions-item>

          <el-descriptions-item label="单位">{{form.unit}}</el-descriptions-item>
          <el-descriptions-item label="是否APP展示">{{form.isShowApp===1?'展示':'不展示'}}</el-descriptions-item>
          <el-descriptions-item label="是否开票">{{form.canInvoice===1?'支持':'不支持'}}</el-descriptions-item>
          <!-- REQ-2026-470053 平台标签，含来源（自动新品/人工）和有效期 -->
          <el-descriptions-item label="平台标签">
            <template v-if="form.platformTagList && form.platformTagList.length">
              <div v-for="tag in form.platformTagList" :key="tag.tagCode">
                <el-tag size="mini" :type="tag.effective ? (tag.tagCode === 'HOT' ? 'danger' : 'primary') : 'info'">{{tag.tagName}}</el-tag>
                {{platformTagStatusText(tag)}}｜来源：{{tag.sourceName}}｜{{tag.effectiveAt}} ~ {{tag.expiredAt}}
              </div>
            </template>
            <span v-else>无</span>
          </el-descriptions-item>
          <!-- REQ-2026-826259 商城活动规则 -->
          <el-descriptions-item label="支持的支付方式">
            {{form.supportedPayModesName || '-'}}
            <el-tag v-if="form.cashOnly" size="mini" type="warning">只支持现金购买</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="余额不足允许现金补差">{{form.allowCashTopUp === false?'不允许':'允许'}}</el-descriptions-item>
          <el-descriptions-item label="商品活动标签">
            <template v-if="form.activityTagList && form.activityTagList.length">
              <el-tag v-for="(tag,index) in form.activityTagList" :key="index"
                      size="mini" type="success" class="activity-tag">{{tag}}</el-tag>
            </template>
            <span v-else>-</span>
          </el-descriptions-item>

        </el-descriptions>
        <div class="custom bg" v-if="form.tag">商品标签：{{form.tag}} </div>
        <!-- <div class="title-box"><span class="txt1">服务配置</span></div>
        <el-descriptions>
          <el-descriptions-item label="服务配置"></el-descriptions-item>
        </el-descriptions> -->
        <template v-if="form.giftData.length > 0">
          <el-descriptions title="正价商品"></el-descriptions>
          <el-table :data="form.giftData">
            <el-table-column label="商品" prop="name" align="center" />
            <el-table-column label="规格" align="center">
              <template slot-scope="{row}">
                {{row.spec || '无规格值'}}
              </template>
            </el-table-column>
            <el-table-column label="数量" prop="num" align="center" />
            <el-table-column label="商品价格" prop="price" align="center" />
          </el-table>
        </template>
        <template v-if="form.giftData1.length > 0">
          <el-descriptions title="赠品商品"></el-descriptions>
          <el-table :data="form.giftData1">
            <el-table-column label="商品" prop="name" align="center" />
            <el-table-column label="规格" align="center">
              <template slot-scope="{row}">
                {{row.spec || '无规格值'}}
              </template>
            </el-table-column>
            <el-table-column label="数量" prop="num" align="center" />
          </el-table>
        </template>
        <div class="title-box"><span class="txt1">权限</span></div>
        <el-descriptions :column="1">
          <el-descriptions-item label="购买权限">{{form.sysbuyNameList}}</el-descriptions-item>
          <el-descriptions-item label="查看权限">{{form.sysLookNameList}}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box" v-if="goodsType"><span class="txt1">推荐商品</span></div>
        <el-descriptions v-if="goodsType">
          <el-descriptions-item label="推荐商品">{{form.sysGoodsRecommendNameList}}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box"><span class="txt1">商品详情</span></div>
        <div class="custom bg">商品详情：
          <div v-html="form.details"></div>
        </div>
        <div class="custom bg" v-if="form.qualification">商品资质：
          <div v-html="form.qualification"></div>
        </div>
        <el-descriptions>
          <el-descriptions-item label="商品排序">{{form.sort}}</el-descriptions-item>
          <el-descriptions-item label="是否设为推荐商品" v-if="goodsType">{{form.isTopRecommend?'是':'否'}}</el-descriptions-item>
          <el-descriptions-item label="状态">{{form.state === 1?'启用':'禁用'}}</el-descriptions-item>
        </el-descriptions>
        <template v-if="shareData">
          <div class="title-box"><span class="txt1">分享朋友圈</span></div>
          <div class="custom " style="display:flex">分享图：
            <div>
              <el-image class="banner-box" v-for="(item,index) in shareData.imgs" :key="index" :src="item.url" :preview-src-list="[item.url]"></el-image>
            </div>
          </div>
          <div class="custom ">分享文案：
            <div style="padding: 5px 0" v-for="(item,index) in shareData.content" :key="index">{{index + 1}}、{{item}}</div>
          </div>
        </template>
      </template>
      <template v-if="!tabType">
        <div class="title-box"><span class="txt1">商品规格</span></div>
        <el-table :data="form.sysGoodsSpecValuecombineList">
          <el-table-column label="规格名" align="center">
            <template slot-scope="{row}">{{row.spec || '无规格值'}}</template>
          </el-table-column>
          <el-table-column label="规格别名" align="center">
            <template slot-scope="{row}">{{row.spec || '无规格值'}}</template>
          </el-table-column>
          <el-table-column label="聚水潭规格编码" prop="jushuitanCode" align="center" />
          <el-table-column label="市场价" prop="retailPrice" align="center" />
          <el-table-column label="总库存" prop="surplusStock" align="center" />
          <!-- <el-table-column label="剩余库存" prop="" align="center" /> -->
          <el-table-column label="商品主图" prop="icon" align="center">
            <template slot-scope="{row}">
              <el-image style="width: 50px; height: 50px" :src="row.specImg" :preview-src-list="[row.specImg]"></el-image>
            </template>
          </el-table-column>
          <el-table-column label="排序" prop="orderNo" align="center" />
        </el-table>
      </template>
    </el-card>
  </div>
</template>

<script>
import sysGoodsApi from '@/api/goods/sysGoods'
import { mallAreaName } from './mallPayMode'
import sysGoodsShareApi from '@/api/goods/sysGoodsShare'
export default {
  props: ['rowItem', 'goodsType'],
  data() {
    return {
      activeName: 'first',
      list: [],
      form: null,
      tabType: 1,
      shareData: null
    }
  },
  created() {
    this.handleShow()
    if (this.goodsType) this.getShareData()
  },
  methods: {
    mallAreaName,
    handleShow() {
      sysGoodsApi.fetchById(this.rowItem.id)
        .then((res) => {
          let data = res.data;
          this.form = data
          this.calcEditData()
          if (!data.isMoreSpec) {
            this.form.retailPrice = data.sysGoodsSpecValuecombineList[0].retailPrice
            this.form.youCode = data.sysGoodsSpecValuecombineList[0].jushuitanCode
          }
        })
    },
    calcEditData() {
      let { sysGoodsPackageConfigShowList } = this.form;
      //正价商品 赠品商品
      let arr = [], arr1 = []
      sysGoodsPackageConfigShowList.forEach(item => {
        if (item.isGift) arr.push(item)
        else arr1.push(item)
      })
      this.$set(this.form, 'giftData1', arr);
      this.$set(this.form, 'giftData', arr1);

    },
    platformTagStatusText(tag) {
      if (tag.status === 0) return '已取消'
      if (tag.status === 2) return '已过期'
      // status=1 但 effective=false，说明还没到生效时间，或刚过期还没被定时任务回写
      return tag.effective ? '生效中' : '未生效'
    },
    getShareData() {
      sysGoodsShareApi.fetchShareData({ sysGoodsId: this.rowItem.id }).then(({ data }) => {
        if (data.length > 0) {
          let { imgs, content } = data[0]
          this.shareData = { imgs: JSON.parse(imgs), content: JSON.parse(content) }
        }
      })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }

}
</script>

<style lang="scss" scoped>
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.banner-box {
  width: 50px;
  height: 50px;
  margin: 2px;
}
/* REQ-2026-826259 商品活动标签 */
.activity-tag {
  margin: 0 4px 4px 0;
}
</style>
